import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const RowWrapper = styled('div', { label: 'RowWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    position: relative;
`;

export const UploadWrapper = styled('div', { label: 'UploadWrapper' })`
    flex: 0 0 50%;
    width: 50%;
`;

const setButton = css`
    align-items: center;
    align-self: center;
    display: flex;
    justify-content: center;
    margin-left: 5px;
    padding: 10px 20px;
    position: relative;
    text-align: center;
    width: auto;
`;

export const LabelButton = styled('label', { label: 'LabelButton' })`
    ${setButton};
`;

export const InputFile = styled('input', { label: 'InputFile' })`
    bottom: 0;
    color: transparent;
    left: 0;
    position: absolute;
    top: 0;
    visibility: hidden;
    width: 100%;
`;

export const UploadButton = styled('button', { label: 'UploadButton' })`
    ${setButton};
`;

export const UploadMessage = styled('div', { label: 'UploadMessage' })`
    margin-top: 10px;
`;

export const LinkCssLeft = styled('div', { label: 'LinkCssLeft' })`
    width: 100px;
`;

